import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as e } from "../../../../../../core/maybe.js";
import a from "../WGLBrush.js";
var t = new Float32Array([.27058823529411763, .4588235294117647, .7098039215686275, 1, .396078431372549, .5372549019607843, .7215686274509804, 1, .5176470588235295, .6196078431372549, .7294117647058823, 1, .6352941176470588, .7058823529411765, .7411764705882353, 1, .7529411764705882, .8, .7450980392156863, 1, .8705882352941177, .8901960784313725, .7490196078431373, 1, 1, 1, .7490196078431373, 1, 1, .8627450980392157, .6313725490196078, 1, .9803921568627451, .7254901960784313, .5176470588235295, 1, .9607843137254902, .596078431372549, .4117647058823529, 1, .9294117647058824, .4588235294117647, .3176470588235294, 1, .9098039215686274, .08235294117647059, .08235294117647059, 1]),
    r = {
  beaufort_ft: t,
  beaufort_m: t,
  beaufort_km: t,
  beaufort_mi: t,
  beaufort_kn: new Float32Array([.1568627450980392, .5725490196078431, .7803921568627451, 1, .34901960784313724, .6352941176470588, .7294117647058823, 1, .5058823529411764, .7019607843137254, .6705882352941176, 1, .6274509803921569, .7607843137254902, .6078431372549019, 1, .7490196078431373, .8313725490196079, .5411764705882353, 1, .8549019607843137, .9019607843137255, .4666666666666667, 1, .9803921568627451, .9803921568627451, .39215686274509803, 1, .9882352941176471, .8352941176470589, .3254901960784314, 1, .9882352941176471, .7019607843137254, .4, 1, .9803921568627451, .5529411764705883, .20392156862745098, 1, .9686274509803922, .43137254901960786, .16470588235294117, 1, .9411764705882353, .2784313725490196, .11372549019607843, 1]),
  classified_arrow: new Float32Array([.2196078431372549, .6588235294117647, 0, 1, .5450980392156862, 1.2117647058823529, 0, 1, 1, 1, 0, 1, 1, .5019607843137255, 0, 1, 1, 0, 0, 1]),
  ocean_current_m: new Float32Array([.3058823529411765, .10196078431372549, .6, 1, .7019607843137254, .10588235294117647, .10196078431372549, 1, .792156862745098, .5019607843137255, .10196078431372549, 1, .6941176470588235, .6941176470588235, .6941176470588235, 1]),
  ocean_current_kn: new Float32Array([0, 0, 0, 1, 0, .1450980392156863, .39215686274509803, 1, .3058823529411765, .10196078431372549, .6, 1, .592156862745098, 0, .39215686274509803, 1, .7019607843137254, .10588235294117647, .10196078431372549, 1, .6941176470588235, .3058823529411765, .10196078431372549, 1, .792156862745098, .5019607843137255, .10196078431372549, 1, .6941176470588235, .7019607843137254, .20392156862745098, 1, .6941176470588235, .6941176470588235, .6941176470588235, 1]),
  single_arrow: new Float32Array([0, 92 / 255, 230 / 255, 1]),
  wind_speed: new Float32Array([0, 0, 0, 1])
};

var s = /*#__PURE__*/function (_a) {
  _inherits(s, _a);

  var _super = _createSuper(s);

  function s() {
    var _this;

    _classCallCheck(this, s);

    _this = _super.apply(this, arguments), _this._desc = {
      magdir: {
        vsPath: "raster/magdir",
        fsPath: "raster/magdir",
        attributes: new Map([["a_pos", 0], ["a_offset", 1], ["a_vv", 2]])
      },
      scalar: {
        vsPath: "raster/scalar",
        fsPath: "raster/scalar",
        attributes: new Map([["a_pos", 0], ["a_offset", 1], ["a_vv", 2]])
      }
    };
    return _this;
  }

  _createClass(s, [{
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "prepareState",
    value: function prepareState(_ref, a) {
      var e = _ref.context;
      e.setBlendingEnabled(!0), e.setBlendFunctionSeparate(1, 771, 1, 771), e.setColorMask(!0, !0, !0, !0), e.setStencilWriteMask(0), e.setStencilTestEnabled(!0), e.setStencilOp(7680, 7680, 7681), e.setStencilFunction(514, a.stencilRef, 255);
    }
  }, {
    key: "draw",
    value: function draw(a, t) {
      if (e(t.source) || 0 === t.source.validPixelCount) return;
      var r = a.timeline;

      if (r.begin(this.name), t.updateVectorFieldVAO(a), "scalar" === a.renderPass) {
        var _e = t.vaoData.scalar;
        _e && this._drawScalars(a, t, _e.vao, _e.elementCount);
      } else {
        var _e2 = t.vaoData.magdir;
        _e2 && this._drawTriangles(a, t, _e2.vao, _e2.elementCount);
      }

      r.end(this.name);
    }
  }, {
    key: "_drawTriangles",
    value: function _drawTriangles(e, a, t, _s) {
      var o = e.context,
          n = e.painter,
          i = a.symbolizerParameters,
          c = i.dataRange ? ["dataRange"] : [];
      "geographic" === i.rotationType && c.push("rotationGeographic");
      var l = n.materialManager.getProgram(e, this._desc.magdir, c);
      o.useProgram(l);
      var m = a.coordScale,
          d = a.opacity,
          f = a.transforms;
      l.setUniform2fv("u_coordScale", m), l.setUniform1f("u_opacity", d), l.setUniformMatrix3fv("u_dvsMat3", f.dvs);
      var u = i.style,
          _ = i.dataRange,
          g = i.rotation,
          p = i.symbolPercentRange;
      l.setUniform4fv("u_colors", r[u] || r.single_arrow), l.setUniform2fv("u_dataRange", _), l.setUniform1f("u_rotation", g), l.setUniform2fv("u_symbolPercentRange", p);

      var y = this._getSymbolSize(e, a);

      l.setUniform2fv("u_symbolSize", y), o.bindVAO(t), o.drawElements(4, _s, 5125, 0);
    }
  }, {
    key: "_drawScalars",
    value: function _drawScalars(e, a, t, r) {
      var _s2 = e.context,
          o = e.painter,
          n = a.symbolizerParameters,
          i = [];
      "wind_speed" === n.style ? i.push("innerCircle") : n.dataRange && i.push("dataRange"), "geographic" === n.rotationType && i.push("rotationGeographic");
      var c = o.materialManager.getProgram(e, this._desc.scalar, i);

      _s2.useProgram(c);

      var l = a.coordScale,
          m = a.opacity,
          d = a.transforms;
      c.setUniform2fv("u_coordScale", l), c.setUniform1f("u_opacity", m), c.setUniformMatrix3fv("u_dvsMat3", d.dvs);
      var f = n.dataRange,
          u = n.symbolPercentRange;
      c.setUniform2fv("u_dataRange", f), c.setUniform2fv("u_symbolPercentRange", u);

      var _ = this._getSymbolSize(e, a);

      c.setUniform2fv("u_symbolSize", _), _s2.bindVAO(t), _s2.drawElements(4, r, 5125, 0);
    }
  }, {
    key: "_getSymbolSize",
    value: function _getSymbolSize(e, a) {
      var t = Math.pow(2, e.displayLevel - a.key.level),
          r = a.symbolizerParameters.symbolTileSize;
      return [r / (Math.round((a.width - a.offset[0]) / r) * r) / t, r / (Math.round((a.height - a.offset[1]) / r) * r) / t];
    }
  }]);

  return s;
}(a);

export { s as default };